"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader, CircleCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OrderSubmissionForm() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}
function OrderFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="text-center py-12">
        <CircleCheck className="size-16 text-primary-active mx-auto mb-6" />
        <h3 className="text-2xl font-display font-bold mb-4 text-foreground">
          Успешно изпратена поръчка!
        </h3>
        <p className="text-muted-foreground mb-8">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" size="lg">
          Изпрати нова поръчка
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit}>
      <div className="space-y-6">
        <FormField control={control} name="name" rules={{
        required: "Името е задължително поле"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Име</FormLabel>
              <FormControl>
                <Input placeholder="Иван Иванов" {...field} />
              </FormControl>
              <FormDescription>
                Въведете пълното си име.
              </FormDescription>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="phone" rules={{
        required: "Телефонът е задължително поле",
        pattern: {
          value: /^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,9}$/,
          message: "Моля, въведете валиден телефонен номер"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Телефон</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+359 88 123 4567" {...field} />
              </FormControl>
              <FormDescription>
                Въведете телефон за контакт.
              </FormDescription>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "Имейлът е задължително поле",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Моля, въведете валиден имейл адрес"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Имейл</FormLabel>
              <FormControl>
                <Input type="email" placeholder="example@domain.com" {...field} />
              </FormControl>
              <FormDescription>
                Въведете валиден имейл адрес.
              </FormDescription>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="address" rules={{
        required: "Адресът е задължително поле"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Адрес</FormLabel>
              <FormControl>
                <Input placeholder='ул. „Света Трайана" 15, София' {...field} />
              </FormControl>
              <FormDescription>
                Адрес за доставка или посочване на място за вземане.
              </FormDescription>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="order_description" rules={{
        required: "Описанието на поръчката е задължително"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Описание на поръчката</FormLabel>
              <FormControl>
                <Textarea placeholder="Опишете какво желаете да поръчате..." className="min-h-32" {...field} />
              </FormControl>
              <FormDescription>
                Колкото по‑подробно, толкова по‑лесно ще обработим поръчката.
              </FormDescription>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="order_type" rules={{
        required: "Моля, изберете тип поръчка"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Тип поръчка</FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Изберете тип" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  <SelectItem value="Доставка">Доставка</SelectItem>
                  <SelectItem value="Само вземане">Само вземане</SelectItem>
                  <SelectItem value="За събитие">За събитие</SelectItem>
                </SelectContent>
              </Select>
              <FormDescription>
                Изберете как искате да получите поръчката.
              </FormDescription>
              <FormMessage />
            </FormItem>} />

        {submitError && <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-red-800 text-sm">{submitError}</p>
          </div>}

        <Button type="submit" disabled={isSubmitting} className="w-full btn-primary" size="lg">
          {isSubmitting ? <>
              <Loader className="animate-spin size-4" />
              Изпраща се...
            </> : "Изпрати поръчка"}
        </Button>
      </div>
    </Form>;
}